/* istanbul ignore file */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import StudioHeader from './StudioHeader/StudioHeader';
import StudioQuote from './StudioQuote/StudioQuote';
import StudioGrid from './StudioGrid/StudioGrid';
import { createMarkup } from '../../../utils/helpers';
// import ImageTreatmentLink from '../../UI/ImageTreatmentLink/ImageTreatmentLink';
// import ImageTreatmentImage from './images/studio-go-behind.jpg';

class Studio extends React.Component {
    render() {
        const { studios, studioCTA, quixote } = this.props;
        const quote = createMarkup(
            '“In an evolving production ecosystem,</br>Hudson Pacific’s experience and platform are more important than ever. </br>We are optimizing our differentiated studio real estate and services offering</br> to perform across cycles.”'
        );

        // const imageTreatmentTitle = 'GO BEHIND<br />THE GATES';

        return (
            <div className="studio-view">
                <Helmet>
                    <title>Redefining Studios in Los Angeles | Hudson Pacific Properties</title>
                    <meta
                        name="description"
                        property="og:description"
                        content="Hudson Pacific's Sunset Studios has revolutionized the studio for those revolutionizing content."
                    />
                </Helmet>

                {/* Studio hero + stats */}
                {studioCTA && <StudioHeader studioCTA={studioCTA} />}

                {/* "Our ability" quote */}
                <StudioQuote textColor="white" quote={quote} author="Victor Coleman" position="Chairman & CEO, Hudson Pacific Properties" />

                {/* Studios grid + Sunset + Quixote copy before and after */}
                {studios && <StudioGrid studios={studios} quixote={quixote} />}

                {/* Go behind the Gates */}
                {/* <ImageTreatmentLink
                    backgroundImage={ImageTreatmentImage}
                    linearOverlay={true}
                    animateIn='slide-in-left-ui'
                    overlayOpacity='0.5'
                    orientation='left'
                    subTitle='SUNSET STUDIOS'
                    title={imageTreatmentTitle}
                    buttonTitle='VISIT WEBSITE'
                    buttonLink='http://hppsunsetstudios.com'
                    isLocalUrl={false}
                /> */}
            </div>
        );
    }
}

Studio.propTypes = {
    isDesktop: PropTypes.bool,
    studios: PropTypes.array,
    studioCTA: PropTypes.array,
    quixote: PropTypes.array,
};

export default connect(
    ({ screen, content }) => ({
        isDesktop: screen.isDesktop,
        studios: content.studios,
        studioCTA: content.studioCTA,
        quixote: content.quixote,
    }),
    null
)(Studio);
